import { render, staticRenderFns } from "./DevBpbjWarehousingListModal.vue?vue&type=template&id=b05646e4&"
import script from "./DevBpbjWarehousingListModal.vue?vue&type=script&lang=js&"
export * from "./DevBpbjWarehousingListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports